import { SASortObject } from 'types/SearchProvider'
import { SORT_BY_AND_ORDER, SORT_VALUES } from 'lib/constructor/constants/hardcodedSaatchiFilters'
import ISO2_GEO_ZONES from 'lib/constants/iso2GeoZones'

export const handleScrollToTop = async (callbackFunction?: () => void): Promise<void> => {
  if (window !== undefined) {
    const scrollToTopAndThen = (callback?: () => void) => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      // Use requestAnimationFrame to check if the page has finished scrolling
      const checkScroll = () => {
        // If the scroll position is at the top, execute the next callback
        if (window.scrollY === 0) {
          // Stop the requestAnimationFrame loop and perform the next callback
          callback?.()
        } else {
          // Otherwise, keep checking
          requestAnimationFrame(checkScroll)
        }
      }
      // Start checking if the scroll is complete
      requestAnimationFrame(checkScroll)
    }

    scrollToTopAndThen(callbackFunction)
  }
}

export const rulesToSendFilters = (filters: Record<string, ReadonlyArray<string>>) => {
  // remove basic query params from selectedFacets
  const basicQueryParam = ['query', 'hitsPerPage', 'page', 'sort']
  const filtersToRemove = ['has_prints', 'category']
  const mergedFiltersToRemove = [...basicQueryParam, ...filtersToRemove]
  const filtersWithoutBasicQueryParams = Object.fromEntries(
    Object.entries(filters).filter(([key]) => !mergedFiltersToRemove.includes(key))
  )

  return filtersWithoutBasicQueryParams
}

export const getSortValues = (sort: string, destinationZone: string = '') => {
  const isSortByPrice = [SORT_VALUES.PRICE_LOW_TO_HIGH, SORT_VALUES.PRICE_HIGH_TO_LOW].includes(
    sort
  )
  const sortObject = {
    ...(SORT_BY_AND_ORDER[sort] || { sortBy: 'relevance', sortOrder: 'descending' }),
  }

  // Needed to include destination zone in the sorting by price
  if (isSortByPrice) {
    sortObject.sortBy = `${SORT_BY_AND_ORDER[sort].sortBy}-${destinationZone}`
  }

  return sortObject
}

const removeDestinationZoneSuffix = (str: string, destinationZone: string) => {
  const uniqueDestinationZones = Array.from(new Set(Object.values(ISO2_GEO_ZONES)))

  if (Boolean(str) && uniqueDestinationZones.includes(destinationZone)) {
    const destinationZoneToRemove = new RegExp(`-${destinationZone}$`)
    return str.replace(destinationZoneToRemove, '')
  }

  return str
}

export const getSortKeyByValue = (
  value: SASortObject,
  destinationZone: string
): string | undefined => {
  return Object.keys(SORT_BY_AND_ORDER).find((key) => {
    const sortByKey = SORT_BY_AND_ORDER[key]
    const sortByWithoutDestinationZone = removeDestinationZoneSuffix(value.sortBy, destinationZone)

    return (
      sortByKey.sortBy === sortByWithoutDestinationZone && sortByKey.sortOrder === value.sortOrder
    )
  })
}
